// De pijlen naast "you may like" schuiven de carrousel, en zetten zichzelf uit
// aan het einde van de rij.
//
// Waarom gedelegeerd op document en niet per knop: de cart drawer wordt door
// Horizon opnieuw opgebouwd via de Section Rendering API bij elke wijziging in
// het mandje. Luisteraars die aan de knoppen zelf hangen zijn na de eerste
// hoeveelheidswijziging weg, en dan doen de pijlen het stilletjes niet meer.
(() => {
  const KAART = 114; // 113px kaart + 1px gat, gemeten bij sava-amsterdam.com

  const rail = (knop) => knop.closest('.jwc-upsell')?.querySelector('.jwc-upsell__rail');

  const bijwerken = (spoor) => {
    const kop = spoor.closest('.jwc-upsell');
    if (!kop) return;
    const eind = spoor.scrollWidth - spoor.clientWidth;
    for (const knop of kop.querySelectorAll('[data-jwc-rail]')) {
      const richting = Number(knop.dataset.jwcRail);
      knop.disabled = eind <= 1 || (richting < 0 ? spoor.scrollLeft <= 1 : spoor.scrollLeft >= eind - 1);
    }
  };

  document.addEventListener('click', (e) => {
    const knop = e.target.closest('[data-jwc-rail]');
    if (!knop) return;
    const spoor = rail(knop);
    if (!spoor) return;
    spoor.scrollBy({ left: Number(knop.dataset.jwcRail) * KAART * 2, behavior: 'smooth' });
  });

  document.addEventListener('scroll', (e) => {
    if (e.target instanceof Element && e.target.classList?.contains('jwc-upsell__rail')) bijwerken(e.target);
  }, true);

  // PayPal wordt in de opmaak weggelaten, maar Shopify houdt in zijn eigen
  // (gesloten) tekening tóch een rij vrij per portemonnee die de winkel aan
  // heeft staan: 58px leegte onder de knop die er wél is. Die hoogte kunnen we
  // niet van binnenuit weghalen, wel van buitenaf terugzetten op wat er echt in
  // staat.
  //
  // Alleen lege ruimte ACHTER de laatste zichtbare knop wordt weggeknipt - nooit
  // een knop zelf. Op een iPhone komt Apple Pay erbij en groeit de rij vanzelf
  // weer mee.
  const portemonnees = () => {
    for (const rij of document.querySelectorAll('#cart-drawer shopify-accelerated-checkout-cart')) {
      const kinderen = [...rij.children].filter((e) => e.getBoundingClientRect().height > 0);
      if (!kinderen.length) continue;
      const boven = rij.getBoundingClientRect().top;
      const onder = Math.max(...kinderen.map((e) => e.getBoundingClientRect().bottom));
      const nodig = Math.round(onder - boven);
      if (nodig > 0 && rij.style.height !== `${nodig}px`) {
        rij.style.height = `${nodig}px`;
        rij.style.overflow = 'hidden';
      }

      // Welke portemonnees er verschijnen hangt van het APPARAAT af, niet van
      // de winkel. Gemeten op live: in Chrome geeft Shopify shop_pay + paypal
      // mee, met een iPhone-UA komt apple_pay erbij. Hij verdeelt de breedte
      // over ALLE ingestelde portemonnees - ook over de kolom van PayPal, die
      // wij verbergen. Drie ingesteld, twee zichtbaar: de derde kolom houdt
      // gewoon zijn plek en dat is de ruimte rechts.
      //
      // Wat wel meewerkt: de kolombreedte volgt de breedte van de rij. Gemeten:
      // rij 360 -> knop 175, rij 545 -> knop 268. Dat is een rechte lijn, dus
      // uit twee metingen volgen het aantal kolommen en de tussenruimte, en
      // daaruit precies hoe breed de rij moet staan zodat de ZICHTBARE knoppen
      // de volle breedte vullen. De lege kolommen schuiven daarbij buiten
      // beeld; de wikkel knipt ze weg.
      //
      // Uitrekenen in plaats van een vaste waarde, want dat aantal verschilt
      // per apparaat en wij kunnen het niet van tevoren weten.
      // Tot de rij op maat staat blijft hij onzichtbaar - anders zie je de
      // knoppen eerst op Shopify's eigen maat verschijnen en twee tellen later
      // groter springen. `visibility` en niet `display`, zodat de plek al
      // ingenomen is en de kassaknop erboven niet verschuift.
      //
      // Er hangt een noodrem aan: gaat het rekenen om wat voor reden dan ook
      // mis, dan komt de rij na drie seconden alsnog in beeld. Een betaalknop
      // die nooit verschijnt is erger dan een die verspringt.
      if (!rij.__jwcNoodrem) {
        rij.setAttribute('data-jwc-meten', '');
        rij.__jwcNoodrem = setTimeout(() => rij.removeAttribute('data-jwc-meten'), 3000);
      }
      clearTimeout(rij.__jwcWacht);
      rij.__jwcWacht = setTimeout(() => {
        vullen(rij);
        rij.removeAttribute('data-jwc-meten');
      }, 200);
    }
  };

  const vullen = (rij) => {
    const kinderen = [...rij.children].filter((e) => e.getBoundingClientRect().height > 0);
    const doel = rij.parentElement ? rij.parentElement.clientWidth : 0;
    if (!kinderen.length || doel < 40) return;

    // Zelfde situatie als de vorige keer? Dan niets doen.
    //
    // Dit is geen zuinigheid maar een noodzaak: het verbreden van de rij laat de
    // knoppen van maat veranderen, de maatwaarnemer ziet dat, en die roept dit
    // weer aan. Zonder deze vergelijking meet en verzet hij zichzelf om de 200ms
    // tot in de eeuwigheid.
    const vinger = `${doel}|${kinderen.map((e) => e.tagName).join(',')}`;
    if (rij.__jwcVinger === vinger) return;
    rij.__jwcVinger = vinger;

    // Twee monsters op de rechte lijn: de huidige breedte en het dubbele.
    rij.style.width = '';
    const w0 = rij.getBoundingClientRect().width;
    const c0 = kinderen[0].getBoundingClientRect().width;
    if (!w0 || !c0) return;
    rij.style.width = `${Math.round(w0 * 2)}px`;
    const w1 = rij.getBoundingClientRect().width;
    const c1 = kinderen[0].getBoundingClientRect().width;

    const helling = (c1 - c0) / (w1 - w0);
    const kolommen = Math.round(1 / helling);
    if (!isFinite(kolommen) || kolommen < 1 || kolommen > 6) {
      // De lijn klopt niet - dan liever niets doen dan iets scheefs.
      rij.style.width = '';
      return;
    }
    const gat = kolommen > 1 ? (w0 - kolommen * c0) / (kolommen - 1) : 0;

    const k = kinderen.length;
    const wens = (doel - (k - 1) * gat) / k;
    const breedte = Math.round(kolommen * wens + (kolommen - 1) * gat);
    rij.style.width = `${breedte}px`;
  };

  // ── de drawer schuift open op de TIK, niet op het antwoord ────────────────
  //
  // Gemeten op live, mobiel: /cart/add.js begint 1ms na de klik en doet er
  // 783ms over; de drawer ging open op 886ms. Bijna alles is dus wachten op de
  // server, en dat gat werd gevuld met een vinkje in de knop en een foto die
  // naar het mandje vliegt. Quinc wil dat niet: drukken, drawer opent.
  //
  // Horizon opent hem pas na het antwoord zolang het mandje leeg is (zie
  // cart-drawer.js: #isCartEmpty). Dus doen we het hier zelf. Zat er al iets in
  // het mandje, dan is hij al open en gebeurt er niets dubbels - open() op een
  // open drawer speelt de schuifanimatie namelijk opnieuw af.
  let bezigTimer = 0;
  document.addEventListener('click', (e) => {
    const doel = e.target instanceof Element ? e.target : null;
    const knop = doel?.closest('button[name="add"]');
    if (!knop || knop.dataset.puppet === 'true' || knop.disabled) return;
    // Een quick-add in een eigen dialoog regelt zijn eigen afhandeling.
    if (doel.closest('.quick-add-modal, dialog[open] .quick-add')) return;

    const drawer = document.getElementById('cart-drawer');
    if (!drawer || drawer.hasAttribute('open') || typeof drawer.open !== 'function') return;

    // Zolang het antwoord onderweg is staat er "your cart is empty" in de
    // drawer. Dat is op dit moment niet waar, dus die tekst blijft weg tot de
    // regels binnen zijn. De sluitknop blijft wel gewoon staan.
    drawer.setAttribute('data-jw-bezig', '');
    clearTimeout(bezigTimer);
    bezigTimer = setTimeout(() => drawer.removeAttribute('data-jw-bezig'), 6000);
    drawer.open();
  }, true);

  const bezigAf = () => {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer || !drawer.hasAttribute('data-jw-bezig')) return;
    if (drawer.querySelector('.cart-drawer--empty')) return;
    clearTimeout(bezigTimer);
    drawer.removeAttribute('data-jw-bezig');
  };

  // Alles wat na een herrender opnieuw gemeten moet worden, samengevat in een
  // animatieframe. `bijwerken` leest scrollWidth en clientWidth en dwingt de
  // browser daarmee de layout ter plekke uit te rekenen; deze waarnemer keek
  // eerst naar het hele document, dus tijdens het opnieuw opbouwen van de drawer
  // gebeurde dat tientallen keren achter elkaar - precies terwijl het paneel
  // binnenschuift.
  let gepland = false;
  const meten = () => {
    if (gepland) return;
    gepland = true;
    requestAnimationFrame(() => {
      gepland = false;
      for (const spoor of document.querySelectorAll('.jwc-upsell__rail')) bijwerken(spoor);
      portemonnees();
      bezigAf();
    });
  };
  meten();
  const wortel = document.getElementById('cart-drawer') || document.documentElement;
  new MutationObserver(meten).observe(wortel, { childList: true, subtree: true });

  // De portemonneeknoppen worden na de rest ingeladen: ze staan al in de DOM
  // terwijl ze nog 0 hoog zijn. Dat is geen wijziging in de DOM, dus de
  // waarnemer hierboven ziet het niet - een maatwaarnemer wel.
  const maten = new ResizeObserver(meten);
  const koppelen = () => {
    for (const rij of document.querySelectorAll('#cart-drawer shopify-accelerated-checkout-cart')) {
      for (const kind of rij.children) maten.observe(kind);
    }
  };
  koppelen();
  new MutationObserver(koppelen).observe(wortel, { childList: true, subtree: true });
})();
